module.exports = {"id":"s2-q4","text":"Did the training require you to upload your own completed work?","multiselect":false,"options":[{"id":"s2-q4-a1","text":"Yes","capability":2,"access":2,"focusarea":[0,4,0,0,0],"conditionalnext":{"capability":6,"next":"s6-q1","else":"s3-q1"}},{"id":"s2-q4-a2","text":"No","next":"s3-q1","capability":0,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s2-q4.json
// module id = 899
// module chunks = 41